import React from 'react';
export function Footer() {
  return <footer className="w-full bg-ink px-8 py-14 text-paper sm:px-14" data-id="element-88" data-mp="32wd0e9mw79qd">
      <div className="mx-auto max-w-6xl" data-id="element-89" data-mp="3gfiu2hdxs9dl">
        <p className="font-display text-3xl tracking-tight" data-id="element-90" data-mp="3ggkal1dq1o2p">
          SCIENCES PRÊTES<span className="align-super text-[0.5em]" data-id="element-91" data-mp="32p5kybpb6omo">™</span>
        </p>
        <p className="mt-10 border-t border-white/10 pt-6 text-xs text-paper/55" data-id="element-92" data-mp="36oo87e4lrbso">
          © 2026 SCIENCES PRÊTES. Tous droits réservés.
        </p>
      </div>
    </footer>;
}